<template>
    <div>
        <v-overlay :value="loadingWorkOrderGroupData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-card height="100vh">
            <v-toolbar dense color="bal-gray">
                <v-card-title>
                    <v-card-title>
                        <span v-if="activeWorkOrderGroup.id">
                            {{ activeWorkOrderGroup.production_order_number }}
                        </span>
                        <span v-else>
                            {{ t("New work order group") }}
                        </span>
                    </v-card-title>
                </v-card-title>
                <v-spacer></v-spacer>
                <v-btn
                    dark
                    color="bal-red"
                    @click="submitEdit"
                    :disabled="tabName === 'Work orders' && user && user.role === PermissionsConstants.ROLE_SUPERADMIN"
                >
                    <v-icon>edit</v-icon>
                    {{ t("Save") }}
                </v-btn>

                <v-btn icon @click="handleCloseClick">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
                <v-tab style="text-transform: none !important;">
                    {{ t("Group info") }}
                </v-tab>
                <v-tab-item>
                    <group-info-edit-tab />
                </v-tab-item>
            </v-tabs>
        </v-card>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Store from "@/store";
import GroupInfoEditTab from "@/pages/work-order/work-order-group-tab-items/group-info-edit-tab";
import { PermissionsConstants } from "@/permissions";
export default {
    name: "work-order-group-edit",
    components: { GroupInfoEditTab },
    data() {
        return {
            tab: 0,
            tabs: ["Group info"]
        };
    },
    async mounted() {
        let workOrderGroupID = this.$route.params.workOrderGroupId;
        if (workOrderGroupID && !this.activeWorkOrderGroup.id && workOrderGroupID !== "new") {
            await this.fetchWorkOrderGroupData(workOrderGroupID);
        }
    },
    computed: {
        ...mapState("WorkOrderStore", ["activeWorkOrderGroup", "loadingWorkOrderGroupData"]),
        ...mapState(["user"]),
        tabName() {
            return this.tabs[this.tab];
        },
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    methods: {
        ...mapMutations("WorkOrderStore", ["toggleWorkOrderGroupDrawer"]),
        ...mapActions("WorkOrderStore", ["fetchWorkOrderGroupData", "submitWorkOrderGroupUpdate", "getWorkOrder"]),
        handleCloseClick() {
            this.toggleWorkOrderGroupDrawer(false);
            this.$router.push({ name: "work-order-list" });
        },
        async submitEdit() {
            let resp = await this.submitWorkOrderGroupUpdate(this.activeWorkOrderGroup);
            await this.fetchWorkOrderGroupData(resp.id);
            if (resp.wo_id) {
                await this.getWorkOrder(resp.wo_id);
                await this.$router.push({ name: "work-order-view", params: { workOrderId: resp.wo_id } });
            } else {
                let workOrderId = this.$route.params.workOrderId ?? null;
                await this.$router.push({
                    name: "work-order-group-view",
                    params: { workOrderGroupId: resp.id, workOrderId }
                });
            }
        }
    }
};
</script>
